"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const React = __importStar(require("react"));
const SvgThumbUp = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, fill: "none" }, props),
    React.createElement("path", { fill: "#58627D", fillRule: "evenodd", d: "M16.717 2.971a3.316 3.316 0 0 1 5.66 2.345v3.451a.51.51 0 0 0 .378.493l1.467.32.03.008a5.61 5.61 0 0 1 4.24 5.73v.007l-.306 5.204-.003.043A7.14 7.14 0 0 1 21.076 27H16.09a7.2 7.2 0 0 1-1.961-.275l-3.708-1.059a5 5 0 0 0-1.325-.196 1.02 1.02 0 0 1-1.005-1.02v-9.895c0-.563.457-1.02 1.02-1.02a6.63 6.63 0 0 0 6.633-6.633V5.316c0-.88.35-1.723.972-2.345m2.345 1.07a1.276 1.276 0 0 0-1.276 1.275v1.586a8.674 8.674 0 0 1-7.653 8.613v8.001q.43.068.85.188l3.708 1.059c.455.13.926.196 1.4.196h4.985a5.1 5.1 0 0 0 5.074-4.571l.305-5.178a3.57 3.57 0 0 0-2.685-3.639l-1.468-.321-.028-.007a2.55 2.55 0 0 1-1.937-2.476v-3.45a1.276 1.276 0 0 0-1.276-1.276", clipRule: "evenodd" }),
    React.createElement("path", { fill: "#D9EAF5", d: "M9.112 12.204H4.52V25.98h4.592z" }),
    React.createElement("path", { fill: "#58627D", fillRule: "evenodd", d: "M3.5 12.204c0-.563.457-1.02 1.02-1.02h4.592c.564 0 1.02.457 1.02 1.02V25.98A1.02 1.02 0 0 1 9.113 27H4.52a1.02 1.02 0 0 1-1.02-1.02zm2.04 1.02V24.96h2.552V13.225z", clipRule: "evenodd" })));
exports.default = SvgThumbUp;
